import React, { useEffect, useState } from 'react';
import './ProgramSection.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { isExternalLink } from '../../../../services/helpers';
import { baseStrapiURL } from '../../../../services/config';

const ProgramSection = ({ strapiData }) => {

    const [backgroundImage, setBackgroundImage] = useState(baseStrapiURL + strapiData.Photo.url);

    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + strapiData.Photo.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    return (
        <section
            className="program-section"
            aria-label={strapiData.Photo.alternativeText}
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className='program-section__content_container'>
                <div className="program-section__content">
                    <h2 className="program-section__title">
                        {strapiData.Texte1}
                        <span className="program-section__subtitle">{strapiData.Texte2}</span>
                        <span className="program-section__subtitle2">{strapiData.Texte3}</span>
                    </h2>
                    <CustomBtn
                        type={isExternalLink(strapiData.Bouton.LienBouton) ? 'external' : 'internal'}
                        title={strapiData.Bouton.TexteBouton}
                        link={
                            strapiData.Bouton.LienBouton === null ?
                                ''
                            :
                                (isExternalLink(strapiData.Bouton.LienBouton) ?
                                    strapiData.Bouton.LienBouton
                                :
                                    '/' + strapiData.Bouton.LienBouton)
                        }
                        bkg_color={'transparent'}
                        bkg_color_hover={'#EEE6DB'}
                        text_color={'#FFFFFF'}
                        text_color_hover={'#361215'}
                        border_color={'#FFFFFF'}
                        border_color_hover={'#EEE6DB'}
                        font_family={"Great Vibes"}
                        font_size={'30px'}
                        font_weight={'normal'}
                        border_radius={'3px'}
                        width={'240px'}
                        height={'55px'}
                        margin={'10px 0'}
                        letter_spacing={2}
                    />
                </div>
            </div>
        </section>
    );
};

export default ProgramSection;